import { Toaster as Sonner, toast } from "sonner";

/**
 * Notificações. Wrapper fino sobre o Sonner só para aplicar os tokens do
 * tema — as telas importam `toast` daqui, não da biblioteca, para que
 * trocar de biblioteca um dia mexa em um arquivo só.
 */
export function Toaster(props) {
  return (
    <Sonner
      position="top-right"
      closeButton
      richColors={false}
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-popover text-popover-foreground border border-border shadow-lg rounded-xl",
          description: "text-muted-foreground",
          actionButton: "bg-primary text-primary-foreground",
          cancelButton: "bg-muted text-muted-foreground",
          error: "border-destructive/40",
          success: "border-success/40",
        },
      }}
      {...props}
    />
  );
}

export { toast };
